export enum PAYMENTS {
    METHOD_CREDIT_CARD = 'ms_paymentsos',
    // UI-only method, actual implementation is 'ms_paymentsos'
    METHOD_CREDIT_CARD_FSA = 'ms_paymentsos_fsa',
    METHOD_PRIMER = 'primer_cc',
    // UI-only method, actual implementation is 'primer_cc'
    METHOD_PRIMER_FSA = 'primer_cc_fsa',
    METHOD_PRIMER_GOOGLE_PAY = 'primer_google_pay',
    METHOD_AMAZON_V2 = 'amazon_v2',
    METHOD_PAYPAL_V3 = 'paypal_v3',
    METHOD_PRIMER_PAYPAL = 'primer_paypal',
    METHOD_PRIMER_KLARNA = 'primer_klarna',
    METHOD_PAYPAL_EXPRESS = 'paypal_express_v2',
    METHOD_GIFT = 'ugiftcert',
    METHOD_RECURLY = 'recurly',
    METHOD_RECURLY_PAYPAL = 'recurly_paypal',
    METHOD_KLARNA = 'klarna',
    METHOD_STRIPE = 'stripe',
    METHOD_GOOGLE_PAY = 'stripe_google_pay',
    METHOD_APPLE_PAY = 'stripe_apple_pay',
    METHOD_PRIMER_APPLE_PAY = 'primer_apple_pay',
    METHOD_PRIMER_VENMO = 'primer_venmo',
    METHOD_VENMO = 'braintree_venmo',
    METHOD_DEFAULT = 'payments',
    METHOD_CASH_ON_DELIVERY = 'cashondelivery',
    METHOD_CHECKMO = 'checkmo',
    METHOD_FREE = 'free',
}

export const STANDARD_PAYMENT_METHODS = [
    PAYMENTS.METHOD_GIFT,
    PAYMENTS.METHOD_CASH_ON_DELIVERY,
    PAYMENTS.METHOD_CHECKMO,
    PAYMENTS.METHOD_FREE,
];

export const PRIMER_METHODS = [
    PAYMENTS.METHOD_PRIMER,
    PAYMENTS.METHOD_PRIMER_FSA,
    PAYMENTS.METHOD_PRIMER_GOOGLE_PAY,
    PAYMENTS.METHOD_PRIMER_APPLE_PAY,
    PAYMENTS.METHOD_PRIMER_PAYPAL,
    PAYMENTS.METHOD_PRIMER_KLARNA,
    PAYMENTS.METHOD_PRIMER_VENMO,
];

export const PAYMENTS_WITH_AUTO_SELECTION = [PAYMENTS.METHOD_AMAZON_V2];

export const PAYPAL_EVENTS = {
    AUTH_PAYPAL: 'authPaypal',
    ERROR_PAYPAL: 'errorPaypal',
    READY_PAYPAL: 'readyPaypal',
    READY_PAYPAL_CART: 'readyPaypalCart',
};
